import React from 'react';
import { motion } from 'framer-motion';
import { formatArea } from '../data/units';
import { useUnits } from '../hooks/useUnits';
import { CheckCircleIcon, HomeIcon } from 'lucide-react';
export function UnitsSection() {
  const {
    units
  } = useUnits();
  const soldUnits = units.filter(unit => unit.stav === 'prodáno' || unit.stav === 'rezervováno').slice(0, 6);
  return <section id="byty" className="py-24 bg-base-cream" data-id="element-240" data-mp="x24g75jt60lm">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-241" data-mp="x2xhhqzzzxwd">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-242" data-mp="t1c3u3fn3fl4">
          <h2 className="font-heading text-4xl md:text-5xl text-primary mb-4" data-id="element-243" data-mp="ea36171l2nww">
            Nabídka bytů
          </h2>
          <p className="text-base-gray max-w-2xl mx-auto" data-id="element-244" data-mp="9ayy0jqeaw85">
            Prohlédněte si naši nabídku bytových jednotek. Kontaktujte nás pro
            více informací a aktuální ceník.
          </p>
        </motion.div>

        {/* Sold/Reserved Units - "Rozjednané jednotky" */}
        {soldUnits.length > 0 && <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mb-16" data-id="element-245" data-mp="3vkn1rv44vdbs">
            <div className="flex items-center gap-3 mb-8" data-id="element-246" data-mp="3bwnsypt4qg90">
              <CheckCircleIcon className="w-6 h-6 text-accent" data-id="element-247" data-mp="3by8oahn9q37x" />
              <h3 className="font-heading text-2xl text-primary" data-id="element-248" data-mp="n41q26k4a64z">
                Rozjednané jednotky
              </h3>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-249" data-mp="r8rlxverzkpw">
              {soldUnits.map((unit, index) => <motion.div key={unit.id} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm relative overflow-hidden" data-id="element-250" data-mp="2j8htg9att0h7" data-mpi={index}>
                  {/* Status badge */}
                  <div className="absolute top-4 right-4" data-id="element-251" data-mp="29h3m5fcmuwdi">
                    <span className={`px-3 py-1 rounded-full text-xs font-semibold ${unit.stav === 'prodáno' ? 'bg-red-100 text-red-800' : 'bg-amber-100 text-amber-800'}`} data-id="element-252" data-mp="1lrsklvngkxyb">
                      {unit.stav === 'prodáno' ? 'Prodáno' : 'Rezervováno'}
                    </span>
                  </div>

                  <div className="flex items-start gap-4" data-id="element-253" data-mp="14jhs6vzxc99">
                    <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0" data-id="element-254" data-mp="3jhh8dn6wesqr">
                      <HomeIcon className="w-6 h-6 text-primary" data-id="element-255" data-mp="3og0ubnlhs4j4" />
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-256" data-mp="g07g5femv558">
                      <h4 className="font-heading text-xl font-bold text-base-dark mb-1" data-id="element-257" data-mp="k112w5gcadwj">
                        {unit.kod}
                      </h4>
                      <p className="text-base-gray text-sm mb-3" data-id="element-258" data-mp="6106p3b0rune">
                        {unit.kategorie} · Vchod {unit.vchod} · {unit.patro}
                      </p>
                      <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm text-base-gray" data-id="element-259" data-mp="2qrhaw9eq8hxx">
                        <span data-id="element-260" data-mp="2vr3pona7e68u">
                          Plocha:{' '}
                          <strong className="text-base-dark" data-id="element-261" data-mp="3b0gwqon0glq7">
                            {formatArea(unit.uzitnaPlochM2)}
                          </strong>
                        </span>
                        {unit.terasaM2 && <span data-id="element-262" data-mp="32988i6uo6n5g">
                            Terasa:{' '}
                            <strong className="text-base-dark" data-id="element-263" data-mp="2x9c4i7lz2vpw">
                              {formatArea(unit.terasaM2)}
                            </strong>
                          </span>}
                      </div>
                    </div>
                  </div>
                </motion.div>)}
            </div>
          </motion.div>}

        {/* CTA buttons */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-264" data-mp="3g0d0qnvpkd5r">
          <a href="#nabidka-bytu" className="inline-block bg-primary hover:bg-primary-light text-white px-8 py-4 rounded-sm transition-colors duration-300 font-medium tracking-wide" data-id="element-265" data-mp="1zfb5ovccahct">
            Zobrazit všechny byty
          </a>
          <a href="#kontakt" className="inline-block bg-transparent border-2 border-primary text-primary hover:bg-primary hover:text-white px-8 py-4 rounded-sm transition-colors duration-300 font-medium tracking-wide" data-id="element-266" data-mp="296p22u8zv11q">
            Kontaktujte nás
          </a>
        </motion.div>
      </div>
    </section>;
}